<div>
  <div class="header-style">
    <div class="h-100">
      <mat-form-field appearance="outline" class="filter-style">
        <mat-select data-testid="products_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #used_filter  id="used_filter"
          name="used_filter">
          <mat-option i18n="@@myProducts" value="approved">My Products</mat-option>
          <mat-option i18n="@@requestedProducts" value="pending">Requested Products</mat-option>
          @if (userType() === utils.userTypes.Distributor || userType() === utils.userTypes.DistributorChild) {
            <mat-option i18n="@@requestedProductsFromManufacturer" value="requested">Requested Products From Manufacturer</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon data-testid="add_product_button" (click)="openAddProduct(null)" class="cursor add-icon" svgIcon="add" i18n-aria-label="@@addProduct" aria-label="Add Product"></mat-icon>
      
      @if (selected === 'approved') {
        @if (productsList.length > 0) {
          <mat-menu #exportMenu="matMenu">
            <button mat-menu-item i18n="@@exportCsv" (click)="exportProducts(1)">Export as CSV</button>
            <button mat-menu-item i18n="@@exportPdf" (click)="exportProducts(2)">Export as PDF</button>
            <button mat-menu-item i18n="@@exportExcel" (click)="exportProducts(3)">Export as Excel</button>
          </mat-menu>
          <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" i18n-aria-label="@@exportProducts" [matMenuTriggerFor]="exportMenu"></mat-icon>
        }
      }
      
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="search_product_input" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="clear_product" class="cursor" matSuffix (click)="clearSearch()" i18n-aria-label="@@clearSearch" aria-label="Clear search">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="search_product" (click)="handleSearchClick()" class="cursor" svgIcon="search" i18n-aria-label="@@searchProducts" aria-label="Search Products"></mat-icon>
    </div>
  </div>

  @if (userType() === utils.userTypes.Distributor || userType() === utils.userTypes.DistributorChild) {
    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
      @for (item of productsList; track item; let itemIndex = $index) {
        <div cdkDrag>
          <div class="example-custom-placeholder"></div>
          <div>
            <mat-card class="lite-box cursor w-100">
              <mat-card-content class="d-flex">
                @if (selected !== 'pending' && selected !== 'requested') {
                  <img class="product-img" (click)="openProduct(item.id, item.name, item)" [src]="item.picture" (error)="onImgError($event)" i18n-alt="@@productImageAlt" alt="Product image">
                }
                @if (selected === 'pending' || selected === 'requested') {
                  <img class="product-img" (click)="openProduct(item.id, item.name, item)" [src]="item.productImage" (error)="onImgError($event)" i18n-alt="@@productImageAlt" alt="Product image">
                }
                <div class="content-box">
                  <div (click)="openProduct(item.id, item.name, item)" class="text-wrapper">
                    @if (selected !== 'pending' && selected !== 'requested') {
                      <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.name}}</div>
                    }
                    @if (selected === 'pending' || selected === 'requested') {
                      <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.productName}}</div>
                    }
                    @if (selected === 'pending' && item.status === 1) {
                      <div i18n="@@pending" class="mat-caption mb-8">Pending</div>
                    }
                    @if (selected === 'pending' && item.status === 3) {
                      <div i18n="@@rejected" class="mat-caption mb-8">Rejected</div>
                    }
                    @if (selected === 'pending' && item.status === 2) {
                      <div i18n="@@approved" class="mat-caption mb-8">Approved</div>
                    }
                    @if (selected === 'requested' && item.status === 1) {
                      <div i18n="@@pending" class="mat-caption mb-8">Pending</div>
                    }
                    @if (selected === 'requested' && item.status === 3) {
                      <div i18n="@@rejected" class="mat-caption mb-8">Rejected</div>
                    }
                    @if (selected === 'requested' && item.status === 2) {
                      <div i18n="@@approved" class="mat-caption mb-8">Approved</div>
                    }
                    @if (selected === 'pending') {
                      <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.requesterUser?.businessName}}</div>
                    }
                    @if (selected === 'pending' && item.requesterUser.type === 1) {
                      <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.requesterUser?.firstName}} {{item.requesterUser?.lastName}}</div>
                    }
                    @if (selected === 'requested') {
                      <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.approverUser?.businessName}}</div>
                    }
                    @if (selected === 'approved') {
                      <div class="mat-caption mb-8 departments-list">
                        @for (department of item.departments; track department; let departmentIndex = $index) {
                          <span>{{department.name}}
                            @if (departmentIndex !== item.departments.length - 1) {
                              <span>, </span>
                            }
                          </span>
                        }
                      </div>
                    }
                    <div class="mat-caption" matTooltip ellipsisTooltip>{{item.description}}</div>
                  </div>
                  @if (selected === 'requested') {
                    <mat-icon class="cursor" (click)="deleteSubscription(item.id)" color="warn" i18n-aria-label="@@deleteSubscription" aria-label="Delete subscription">delete_outline</mat-icon>
                  }
                  @if (selected === 'pending' && item.type !== 2) {
                    <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label="@@moreOptions" aria-label="More options">more_vert</mat-icon>
                  }
                  <mat-menu #menu="matMenu">
                    <button i18n="@@productDetails" data-testid="goToProduct" (click)="goToProduct(item.productId, item.productName)" mat-menu-item>Product details</button>
                  </mat-menu>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      }
    </div>
  }

  @if (userType() === utils.userTypes.Manufacturer || userType() === utils.userTypes.ManufacturerChild) {
    <div>
      @for (item of productsList; track item; let itemIndex = $index) {
        <div>
          <div class="example-custom-placeholder"></div>
          <div>
            <mat-card class="lite-box cursor">
              <mat-card-content class="d-flex w-100">
                  @if (selected !== 'pending' && selected !== 'requested') {
                    <img class="product-img" (click)="openProduct(item.id, item.name, item)" [src]="item.picture" (error)="onImgError($event)">
                  }
                  @if (selected === 'pending' || selected === 'requested') {
                    <img class="product-img" (click)="openProduct(item.id, item.name, item)" [src]="item.productImage" (error)="onImgError($event)">
                  }
                  <div class="content-box">
                    <div (click)="openProduct(item.id, item.name, item)" class="text-wrapper">
                      @if (selected !== 'pending' && selected !== 'requested') {
                        <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.name}}</div>
                      }
                      @if (selected === 'pending' || selected === 'requested') {
                        <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.productName}}</div>
                      }
                      @if (selected === 'pending' && item.status === 1) {
                        <div i18n="@@pending" class="mat-caption mb-8">Pending</div>
                      }
                      @if (selected === 'pending' && item.status === 3) {
                        <div i18n="@@rejected" class="mat-caption mb-8">Rejected</div>
                      }
                      @if (selected === 'pending' && item.status === 2) {
                        <div i18n="@@approved" class="mat-caption mb-8">Approved</div>
                      }
                      @if (selected === 'requested' && item.status === 1) {
                        <div i18n="@@pending" class="mat-caption mb-8">Pending</div>
                      }
                      @if (selected === 'requested' && item.status === 3) {
                        <div i18n="@@rejected" class="mat-caption mb-8">Rejected</div>
                      }
                      @if (selected === 'requested' && item.status === 2) {
                        <div i18n="@@approved" class="mat-caption mb-8">Approved</div>
                      }
                      @if (selected === 'pending') {
                        <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.requesterUser?.businessName}}</div>
                      }
                      @if (selected === 'pending' && item.requesterUser.type === 1) {
                        <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.requesterUser?.firstName}} {{item.requesterUser?.lastName}}</div>
                      }
                      @if (selected === 'requested') {
                        <div class="mat-subtitle-1" matTooltip ellipsisTooltip>{{item.approverUser?.businessName}}</div>
                      }
                      @if (selected === 'approved') {
                        <div class="mat-caption mb-8 departments-list">
                          @for (department of item.departments; track department; let departmentIndex = $index) {
                            <span>{{department.name}}
                              @if (departmentIndex !== item.departments.length - 1) {
                                <span>, </span>
                              }
                            </span>
                          }
                        </div>
                      }
                      <div class="mat-caption" matTooltip ellipsisTooltip>{{item.description}}</div>
                    </div>
                    @if (selected === 'requested') {
                      <mat-icon class="cursor" (click)="deleteSubscription(item.id)" color="warn" i18n-aria-label="@@deleteSubscription" aria-label="Delete subscription">delete_outline</mat-icon>
                    }
                    @if (selected === 'pending' && item.type !== 2) {
                      <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label="@@moreOptions" aria-label="More options">more_vert</mat-icon>
                    }
                    <mat-menu #menu="matMenu">
                      <button i18n="@@productDetails" data-testid="goToProduct" (click)="goToProduct(item.productId, item.productName)" mat-menu-item>Product details</button>
                    </mat-menu>
                  </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      }
    </div>
  }

  @if (productsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-aria-label="@@noProducts" aria-label="No products available">
  }
</div>
